import { SolarSchoolsTheme } from "./utilities/Theme/theme";
import { ThemeProvider } from "@material-ui/core/styles";
import ReactDOM from "react-dom";
import React from "react";
import { SolarVsGridBars } from "./ComparisonBars/SolarVsGridBars/SolarVsGridBars";

const init = async (api) => {
  const element = document.getElementById("comparison-bars");

  if (!element) {
    return;
  }

  try {
    const summary = await api.call("schemas", "getSummary", [1]);
    ReactDOM.render(
      <ThemeProvider theme={SolarSchoolsTheme}>
        <div
          style={{
            position: "absolute",
            marginLeft: "30%",
            height: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          <SolarVsGridBars
            solarGenerated={
              summary &&
              summary.energy &&
              summary.energy.today &&
              summary.energy.today.solarGenerated
            }
            gridConsumed={
              summary &&
              summary.energy &&
              summary.energy.today &&
              summary.energy.today.gridConsumed
            }
          />
        </div>
      </ThemeProvider>,
      element
    );
  } catch (err) {
    console.error(err);
  }
};

export default init;



// WEBPACK FOOTER //
// ./resources/assets/js/app/comparisonBars.js